// @flow
import * as React from 'react'
import CalendarIcon from 'mz-icons/calendar'
import type Moment from 'moment'
import BaseField from '../../../core/BaseField'
import Lightbox from '../../../core/Lightbox'
import Button from '../../../core/Button'
import Input from '../../../core/Input'
import DesktopDateField from '../DesktopDateField'
import VerticalCalendar from '../VerticalCalendar'
import { Container, Footer, InputContainer } from './elements'
import formatDate from '../../../utils/formatDate'

// Types
import type { Props as DesktopDateTimeFieldProps } from '../DesktopDateField'

export type Props = DesktopDateTimeFieldProps
type State = {
  value: Moment,
}

/**
 * Simple pretty select input field that can be used to showed
 * simple selectors.
 */
class MobileDateField extends React.Component<Props, State> {
  static defaultProps = DesktopDateField.defaultProps

  state = {
    value: null,
  }

  lightboxController = null

  constructor(props: Props, ...args: any) {
    super(props, ...args)
    this.state = { value: props.input.value }
  }

  handleInputClick = () => {
    this.lightboxController && this.lightboxController.open()
  }

  handleClickCancel = ({
    closeManually = true,
  }: { closeManually: boolean } = {}) => {
    const {
      input: { onBlur },
    } = this.props
    onBlur && onBlur()

    if (closeManually) {
      this.lightboxController && this.lightboxController.close()
    }
  }

  handleCloseLightbox = () => {
    this.handleClickCancel({ closeManually: false })
  }

  handleChangeDate = (value: any) => {
    this.setState({ value })
  }

  handleClickSelect = () => {
    const {
      input: { onChange },
    } = this.props
    onChange && onChange(this.state.value)
    this.handleClickCancel()
  }

  renderLightbox = () => (
    <Container>
      <VerticalCalendar
        value={this.state.value}
        onChange={this.handleChangeDate}
      />
      <Footer>
        <Button onClick={this.handleClickSelect}>Select</Button>
      </Footer>
    </Container>
  )

  renderInput = ({
    input: { value, onFocus, onBlur, onClick },
    style,
    props: { dateFormat, disableTime, ...props },
  }: any) => (
    <InputContainer>
      <Input
        style={style}
        props={props}
        input={{
          value: formatDate(value, disableTime, dateFormat),
          onClick,
          onFocus,
          onBlur,
        }}
      />
      <Lightbox
        controllerRef={(c) => (this.lightboxController = c)}
        title={this.props.label || this.props.placeholder}
        render={this.renderLightbox}
        appearance="mobile"
        onClose={this.handleCloseLightbox}
      />
    </InputContainer>
  )

  render() {
    return (
      <BaseField
        {...this.props}
        input={{
          ...this.props.input,
          onClick: this.handleInputClick,
        }}
        renderPrefix={() => <CalendarIcon />}
        type="static"
        renderInput={this.renderInput}
        emptyValue={null}
        selectable
      />
    )
  }
}

export default MobileDateField
